/**
 * Banner Component
 * Notification banners are rendered server-side (cache-safe).
 * All visibility logic — active flag, date range, per-user dismiss — runs here.
 */
const banner = {
    options: {
        containerSelector: '#rg-banners',
        bannerSelector: '.rg-banner',
        closeSelector: '.rg-banner__close',
        storagePrefix: 'rg_banner_',
    },

    init() {
        const container = document.querySelector(this.options.containerSelector);
        if (!container) return;

        const banners = container.querySelectorAll(this.options.bannerSelector);
        if (!banners.length) return;

        let anyVisible = false;

        banners.forEach((el) => {
            if (this.shouldShow(el)) {
                el.classList.remove('hidden');
                el.classList.add('flex');
                anyVisible = true;
                this.bindClose(el);
            }
        });

        if (anyVisible) {
            // Reveal container — swap hidden for flex (avoids display conflict in HTML)
            container.classList.remove('hidden');
            container.classList.add('flex');
        }
    },

    shouldShow(el) {
        if (el.dataset.active !== '1') return false;

        const from = el.dataset.dateFrom || '';
        const to   = el.dataset.dateTo   || '';

        // Both dates are required
        if (!from || !to) return false;

        const today = this.todayYmd();
        if (today < from || today > to) return false;

        const id   = el.dataset.bannerId;
        const days = parseInt(el.dataset.dismissDays, 10) || 30;

        return !this.isDismissed(id, days);
    },

    /** Returns today as YYYYMMDD — matches ACF date_picker Ymd return format. */
    todayYmd() {
        const d   = new Date();
        const y   = d.getFullYear();
        const m   = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}${m}${day}`;
    },

    isDismissed(id, days) {
        const stored = localStorage.getItem(this.options.storagePrefix + id);
        if (!stored) return false;
        return (Date.now() - parseInt(stored, 10)) < (days * 86400000);
    },

    dismiss(id) {
        localStorage.setItem(this.options.storagePrefix + id, Date.now().toString());
    },

    bindClose(el) {
        const btn = el.querySelector(this.options.closeSelector);
        if (!btn) return;

        btn.addEventListener('click', () => {
            this.dismiss(el.dataset.bannerId);
            el.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
            el.style.opacity    = '0';
            el.style.transform  = 'translateY(12px)';
            setTimeout(() => el.remove(), 280);
        });
    },
};

export { banner };
